import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Table, FLink } from '@components';
import { useNavigate } from 'react-router-dom';

import { addMonths, getMonth, subMonths } from 'date-fns';
import { CONTATO_EMPRESTIMO } from '@utils/paths';
import { EmprestimoService } from '../../../common/services/emprestimo';

const service = new EmprestimoService();

const meses = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

const dataAtual = new Date();
const mesAtual = getMonth(dataAtual);
const mesSeguinte = getMonth(addMonths(dataAtual, 1));
const mesPassado = getMonth(subMonths(dataAtual, 1));

export const Calendario = () => {
  const navigate = useNavigate();
  const [itensCalendario, setItensCalendario] = useState([]);

  useEffect(() => {
    service.obterCalendario().then((res) => {
      setItensCalendario(res);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Forluz - Calendário de empréstimo</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Calendário de empréstimo</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <h3 className="mb-3 fs-6">
            Acompanhe as datas limites para processamento de empréstimo. Em caso
            de dúvidas, envie uma mensagem para o setor de empréstimos com sua
            dúvida, sugestão e/ou reclamação no{'  '}
            <FLink className="d-inline fs-6" to={CONTATO_EMPRESTIMO}>
              Fale Conosco.
            </FLink>
          </h3>
          <hr className="mb-3" />
          {itensCalendario.map((itensTipo) => {
            const tituloTable = itensTipo[0].TipoData;
            return (
              <>
                <div className="d-flex mb-3 justify-content-center">
                  <h4 className="fw-bold">{tituloTable}</h4>
                </div>

                <Table
                  key={tituloTable}
                  className="mb-5"
                  columns={[
                    'Evento',
                    meses[mesPassado],
                    meses[mesAtual],
                    meses[mesSeguinte],
                  ]}
                >
                  {itensTipo.map((evento) => (
                    <tr key={evento.Evento}>
                      <td>{evento.Evento}</td>
                      <td>{evento.MesAnterior}</td>
                      <td>{evento.MesAtual}</td>
                      <td>{evento.MesPosterior}</td>
                    </tr>
                  ))}
                </Table>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};
